import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { media } from "../../../../../styles"

export const AuthorContainer = styled.div`
  border-top: solid 0.2rem var(--color-black);
  max-width: 104rem;
  margin: 0 auto 10rem;

  ${media.tabland`
  width: 90%;
  margin: 0 5% 10rem;
  `}

  padding: 5rem 0;
  display: flex;
  align-items: center;

  ${media.phone`
  align-items: flex-start;
  `}

  ${media.phonesmall`
flex-direction: column;
align-items: center;
  `}
`
export const AuthorImageContainer = styled.div`
  ${media.phone`
  margin-bottom: 2rem;
  `}
`
export const AuthorImage = styled(GatsbyImage)`
  width: 20rem;
  height: 20rem;
  border-radius: 50%;

  ${media.phone`
  width: 15rem;
  height: 15rem;
  `}
`

export const AuthorTextContainer = styled.div`
  margin-left: 5rem;

  ${media.phone`
  margin-left: 2.5rem;
  `}

  ${media.phonesmall`
  margin-left: 0rem;
text-align: center;
  `}
`
export const AuthorName = styled.p`
  font-family: var(--font-body);
  font-size: var(--font-size-subheading);
  line-height: var(--line-height-bodyS);
  font-weight: bold;
  font-family: var(--font-heading);
`
export const AuthorBio = styled.p`
  font-family: var(--font-body);
  font-size: var(--font-size-bodyM);
  line-height: var(--line-height-bodyS);

  ${media.phone`
  font-size: var(--font-size-bodyS);
  `}
`
